import { render, staticRenderFns } from "./addWord_dialog.vue?vue&type=template&id=8ca53d48&scoped=true"
import script from "./addWord_dialog.vue?vue&type=script&lang=ts"
export * from "./addWord_dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca53d48",
  null
  
)

export default component.exports